/**
 * An error that occurs when a state is currently not valid.
 *
 * E.g. if a switch-case statement is called for a value that is currently not handled.
 */
export class NotSupportedError extends Error {}
